import { Button, Card, Result, Row, Typography } from "antd";
import React from "react";

const { Title, Text } = Typography;

interface Props {
  bookedDate: Date | undefined;
  price: string;
  description: string | undefined;
}

const Summary: React.FC<Props> = ({ bookedDate, price, description }) => {
  return (
    <>
      <Card style={{ width: "100%" }}>
        <Result
          status="success"
          title="Arrangementet er booket!"
          subTitle="Bekreftelse er sendt på mail til hovedkontakt. Dette kan ta noen minutter, venligst vent eller sjekk søppelpost."
        />
        <Row>
          <Title level={5}>Oppsummering</Title>
        </Row>
        <Row>
          <ul>
            <li>
              <Text strong>Dato:</Text>{" "}
              {bookedDate?.toLocaleDateString("no", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </li>
            <li>
              <Text strong>Pris:</Text> {price}
            </li>
            {description && description !== "" && (
              <li>
                <Text strong>Andre henvendelser:</Text> {description}
              </li>
            )}
          </ul>
        </Row>
        <Row>
          <Text>
            Dere vil få tildelt en hovedansvarlig fra Bindeleddet som tar kontakt i god tid før arrangementet.{" "}
          </Text>
        </Row>
        <Row>
          <Text>
            Ta kontakt på <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a> om dere skulle ha noen
            henvendelser før dette!
          </Text>
        </Row>
        <br />
        <Row>
          <Text italic>Takk for at dere velger å bruke Bindeleddet! </Text>
        </Row>
      </Card>

      <Row style={{ justifyContent: "space-between", width: "100%", padding: "10px 0" }}>
        <Button href="/company/company-profile/" type="primary" size="large" style={{ margin: "auto" }}>
          Tilbake til bedriftssiden
        </Button>
      </Row>
    </>
  );
};

export default Summary;
